export const INIT_MAP_STATE = "INIT_MAP_STATE";
export const UPDATE_MAP_STATE = "UPDATE_MAP_STATE";
export const CLEAR_MAPS_STATE = "CLEAR_MAPS_STATE";
export const MAINTAIN_MAPS_STATE_FOR_SLIDE_IDS = "MAINTAIN_MAPS_STATE_FOR_SLIDE_IDS";
export const REMOVE_MAPS_STATE = "REMOVE_MAPS_STATE";
export const UPDATE_SLIDE = "UPDATE_SLIDE";
export const UPDATE_GRID_STATE = "UPDATE_GRID_STATE";
export const UPDATE_DISPLAY_SETTING = "UPDATE_DISPLAY_SETTING";
export const UPDATE_FIELD_DISPLAY_SETTING = "UPDATE_FIELD_DISPLAY_SETTING";
export const UPDATE_ANNOTATION_STATE = "UPDATE_ANNOTATION_STATE";
export const APPEND_ANNOTATION_STATE = "APPEND_ANNOTATION_STATE";
export const ADD_ANNOTATION = "ADD_ANNOTATION";
export const DELETE_ANNOTATION = "DELETE_ANNOTATION";
export const UPDATE_BLOOD_ANNOTATION_STATE = "UPDATE_BLOOD_ANNOTATION_STATE";
export const UPDATE_IHC_STATE = "UPDATE_IHC_STATE";
export const UPDATE_SELECTED_ANNOTATION_LIST = "UPDATE_SELECTED_ANNOTATIONS";
export const DELETED_SLIDE_ERROR = 'DELETED_SLIDE_ERROR';
export const SLIDE_NOT_FOUND_ERROR = 'SLIDE_NOT_FOUND_ERROR';
export const PERMISSION_DENIED_ERROR = 'PERMISSION_DENIED_ERROR';